import { ResumeSectionType, ContactInfo } from '@applicator/shared'

type ResumeData = Record<ResumeSectionType, unknown>

import {
  type PendingSectionSaveRef,
  scheduleDebouncedResumeSectionSave,
} from '../../utils/resumeSectionSaveScheduler'
import { scrollToLastItem, toggleSection } from './helpers'

// Handle section add button click
export function handleSectionAddClick(
  sectionType: ResumeSectionType,
  expandedSections: Set<ResumeSectionType>,
  setExpandedSections: React.Dispatch<React.SetStateAction<Set<ResumeSectionType>>>,
  addSummaryEntryRef: React.MutableRefObject<(() => void) | null>,
  addWorkExperienceRef: React.MutableRefObject<(() => void) | null>,
  addEducationRef: React.MutableRefObject<(() => void) | null>,
  addTargetTitleRef: React.MutableRefObject<(() => void) | null>,
  addContactExtraFieldRef: React.MutableRefObject<(() => void) | null>,
  addCertificationRef: React.MutableRefObject<(() => void) | null>,
  addProjectRef: React.MutableRefObject<(() => void) | null>,
  addInterestRef: React.MutableRefObject<(() => void) | null>,
  leftPanelRef: React.RefObject<HTMLDivElement>
) {
  if (sectionType === 'professional_summary') {
    if (!expandedSections.has('professional_summary')) {
      toggleSection('professional_summary', expandedSections, setExpandedSections)
      setTimeout(() => {
        addSummaryEntryRef.current?.()
        scrollToLastItem('[data-summary-id]', leftPanelRef, 200)
      }, 350)
    } else {
      addSummaryEntryRef.current?.()
      scrollToLastItem('[data-summary-id]', leftPanelRef, 200)
    }
  } else if (sectionType === 'work_experience') {
    if (!expandedSections.has('work_experience')) {
      toggleSection('work_experience', expandedSections, setExpandedSections)
      setTimeout(() => {
        addWorkExperienceRef.current?.()
        scrollToLastItem('[data-company-id]', leftPanelRef, 200)
      }, 350)
    } else {
      addWorkExperienceRef.current?.()
      scrollToLastItem('[data-company-id]', leftPanelRef, 200)
    }
  } else if (sectionType === 'target_title') {
    if (!expandedSections.has('target_title')) {
      toggleSection('target_title', expandedSections, setExpandedSections)
      setTimeout(() => {
        addTargetTitleRef.current?.()
        scrollToLastItem('[data-title-id]', leftPanelRef, 200)
      }, 350)
    } else {
      addTargetTitleRef.current?.()
      scrollToLastItem('[data-title-id]', leftPanelRef, 200)
    }
  } else if (sectionType === 'contact_info') {
    if (!expandedSections.has('contact_info')) {
      toggleSection('contact_info', expandedSections, setExpandedSections)
      setTimeout(() => {
        addContactExtraFieldRef.current?.()
        scrollToLastItem('[data-contact-extra-id]', leftPanelRef, 200)
      }, 350)
    } else {
      addContactExtraFieldRef.current?.()
      scrollToLastItem('[data-contact-extra-id]', leftPanelRef, 200)
    }
  } else if (sectionType === 'education') {
    if (!expandedSections.has('education')) {
      toggleSection('education', expandedSections, setExpandedSections)
      setTimeout(() => {
        addEducationRef.current?.()
        scrollToLastItem('[data-education-id]', leftPanelRef, 200)
      }, 350)
    } else {
      addEducationRef.current?.()
      scrollToLastItem('[data-education-id]', leftPanelRef, 200)
    }
  } else if (sectionType === 'certifications') {
    if (!expandedSections.has('certifications')) {
      toggleSection('certifications', expandedSections, setExpandedSections)
      setTimeout(() => {
        addCertificationRef.current?.()
        scrollToLastItem('[data-certification-id]', leftPanelRef, 200)
      }, 350)
    } else {
      addCertificationRef.current?.()
      scrollToLastItem('[data-certification-id]', leftPanelRef, 200)
    }
  } else if (sectionType === 'projects') {
    if (!expandedSections.has('projects')) {
      toggleSection('projects', expandedSections, setExpandedSections)
      setTimeout(() => {
        addProjectRef.current?.()
        scrollToLastItem('[data-project-id]', leftPanelRef, 200)
      }, 350)
    } else {
      addProjectRef.current?.()
      scrollToLastItem('[data-project-id]', leftPanelRef, 200)
    }
  } else if (sectionType === 'interests') {
    if (!expandedSections.has('interests')) {
      toggleSection('interests', expandedSections, setExpandedSections)
      setTimeout(() => {
        addInterestRef.current?.()
      }, 350)
    } else {
      addInterestRef.current?.()
    }
  }
}

// Update contact info
export function updateContactInfo(
  field: keyof ContactInfo,
  value: ContactInfo[keyof ContactInfo],
  resumeData: ResumeData,
  setResumeData: React.Dispatch<React.SetStateAction<ResumeData>>,
  saveTimeoutRef: React.MutableRefObject<Record<ResumeSectionType, NodeJS.Timeout | null>>,
  saveResumeContent: (
    section: ResumeSectionType,
    data: Record<string, unknown>,
    skipStateUpdate?: boolean,
  ) => Promise<{ ok: true } | { ok: false; error: string }>,
  resumeId: string | undefined,
  getActiveResumeId: () => string | undefined,
  pendingSectionSaveRef?: PendingSectionSaveRef,
) {
  const updated = { ...(resumeData.contact_info as ContactInfo), [field]: value }
  setResumeData((prev: ResumeData) => ({ ...prev, contact_info: updated }))

  scheduleDebouncedResumeSectionSave(
    saveTimeoutRef,
    'contact_info',
    resumeId,
    getActiveResumeId,
    updated,
    saveResumeContent,
    undefined,
    pendingSectionSaveRef,
  )
}
